import React, { useState } from 'react'
import analyticsHelper from '../AnalyticsHelper.js'
//import firebase from '../FirebaseConfig'

function HTPillTag (props) {

  // this worked, but caused an error since it causes a change mid-render
  // functional components should only change stuff after render, with hooks
  // the onClick below called setClicked(true) instead of props.onClick, which caused a re-render
  //const [clicked, setClicked] = useState(false);
  //if (clicked) {
    //props.onClick(props.title)
  //}

  return (
    <div className="tag" onClick={() => {
      props.onClick(props.title);
      //firebase.analytics().logEvent('pill click with: '+props.title)}
      analyticsHelper.genEvent(analyticsHelper.EVENT_SELECT, analyticsHelper.SELECT_PILL, props.title)}
    } >{props.title}</div>
  )
}

export default HTPillTag



// WEBPACK FOOTER //
// src/components/HTPillTag.js